import { Icon } from '@fashionnovateam/nova-ui-toolkit';
import { formatPrice } from '../../../PurchaseOrderDetail/Utils/formatPrice';
import { PurchaseOrderRevisionRequestedActivityDetail } from '../../../../Lib/Types/purchase-order-revision';

export function Changeback(
  props: NonNullable<
    PurchaseOrderRevisionRequestedActivityDetail['chargeback']
  >,
) {
  const { value, type } = props;

  const chargebackValue =
    type === 'percent'
      ? `${value}%`
      : `${formatPrice(value, false, false)}/unit`;

  const chargebackFormatted = `${chargebackValue} chargeback applied`;

  return (
    <div className="flex flex-row items-center gap-3 bg-warning-100 p-4 rounded-lg">
      <Icon
        name="information/information-triangle"
        className="text-warning-700"
        variant="solid"
        size="20"
      />
      <span className="text-base-primary text-sm">{chargebackFormatted}</span>
    </div>
  );
}
